/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { PieEchart, LineEchart } from '@/components/page-echarts';
import CNoData from '@/components/CNoData.vue';
import { useFeedingTotal, useFeedingRatio, useFeedingTrend } from '../hooks/useFeedingForm';
export default defineComponent({
  name: 'ReportForm',
  components: {
    PieEchart: PieEchart,
    LineEchart: LineEchart,
    CNoData: CNoData
  },
  props: {
    type: {
      type: Number,
      default: 0
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    }
  },
  setup: function setup(props) {
    var params = ref({
      type: props.type,
      startTime: props.startTime,
      endTime: props.endTime
    });
    var _useFeedingTotal = useFeedingTotal(params),
      _useFeedingTotal2 = _slicedToArray(_useFeedingTotal, 2),
      feedingTotal = _useFeedingTotal2[0],
      getFeedingTotalAsync = _useFeedingTotal2[1];
    var summaryData = computed(function () {
      return [{
        num: feedingTotal.value.proValue,
        desc: '进料量(吨)'
      }, {
        num: feedingTotal.value.feedCarNumber,
        desc: '进料车次(车)'
      }, {
        num: feedingTotal.value.feedFreight,
        desc: '运费(万)'
      }];
    });
    var tabs = ref(['进料量', '运费']);
    var curTab = ref('进料量');
    var tabClick = function tabClick(val) {
      curTab.value = val;
    };
    // 进料占比
    var _useFeedingRatio = useFeedingRatio(params),
      _useFeedingRatio2 = _slicedToArray(_useFeedingRatio, 2),
      feedingRatio = _useFeedingRatio2[0],
      getFeedingRatioAsync = _useFeedingRatio2[1];
    // 进料占比
    var categoryFeedingCount = computed(function () {
      var list = [];
      var unit = '';
      if (curTab.value === '进料量') {
        list = feedingRatio.value.feedWeight.map(function (item) {
          return {
            name: item.name,
            value: +item.value,
            percent: item.ratio_num
          };
        }).filter(function (item) {
          return item.value;
        });
        unit = '吨';
      }
      if (curTab.value === '运费') {
        list = feedingRatio.value.feedFreight.map(function (item) {
          return {
            name: item.name,
            value: +item.value,
            percent: item.ratio_num
          };
        }).filter(function (item) {
          return item.value;
        });
        unit = '元';
      }
      return {
        pieData: list,
        unit: unit,
        customTooltip: true,
        labelShow: true,
        customLabel: true,
        fontSize: 12,
        labelFormatter: function labelFormatter(params) {
          var res = "".concat(params.percent, "%\n").concat(params.value, "\n").concat(params.name);
          return res;
        },
        tooltipFormatter: function tooltipFormatter(params) {
          var res = "\n              <div >\n              ";
          if (curTab.value === '进料量') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                      <div>\n                        <span style=\"font-size: 12px;\">").concat(params.percent, "%</span>\n                      </div>\n                      <div>\n                        <span style=\"font-size: 12px;\">").concat(params.value, "\u5428</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          if (curTab.value === '运费') {
            res += "\n                  <div class=\"flex align-start\">\n                    <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n                    <div>\n                      <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                      <div>\n                        <span style=\"font-size: 12px;\">").concat(params.percent, "%</span>\n                      </div>\n                      <div>\n                        <span style=\"font-size: 12px;\">").concat(params.value, "\u5143</span>\n                      </div>\n                    </div>\n                  </div>\n                ");
          }
          res += '</div>';
          return res;
        }
      };
    });
    // 计算时间是否大于一天
    var outweighOneDay = computed(function () {
      var start = new Date(params.value.startTime).getTime();
      var end = new Date(params.value.endTime).getTime();
      var diff = Math.abs(end - start); // 绝对值，确保正数
      var oneDayMs = 24 * 60 * 60 * 1000;
      // 超过一天返回true，一天之内（含等于）返回false
      return diff > oneDayMs;
    });
    // const curTabS = ref('进料量');
    // const tabClickS = (val: string) => {
    //   curTabS.value = val;
    // };
    var _useFeedingTrend = useFeedingTrend(params),
      _useFeedingTrend2 = _slicedToArray(_useFeedingTrend, 2),
      feedingTrend = _useFeedingTrend2[0],
      getFeedingTrendAsync = _useFeedingTrend2[1];
    // 进料趋势
    var categoryPriceCount = computed(function () {
      var list = [];
      var xLabels = [];
      list = feedingTrend.value.map(function (item) {
        return +item.value;
      });
      xLabels = feedingTrend.value.map(function (item) {
        return item.name;
      });
      // if (curTabS.value === '进料量') {
      //   list = trendData.value.settleVlaueList.map((item) => {
      //     return item.value;
      //   });
      //   xLabels = trendData.value.settleVlaueList.map((item) => {
      //     return item.date;
      //   });
      // }
      // if (curTabS.value === '运费') {
      //   list = trendData.value.totMoneyList.map((item) => {
      //     return item.value;
      //   });
      //   xLabels = trendData.value.totMoneyList.map((item) => {
      //     return item.date;
      //   });
      // }
      return {
        lineData: list,
        xLabels: xLabels,
        legendData: [],
        yName: '',
        height: '200px',
        showDetail: true,
        formatter: function formatter(params) {
          // let res = `
          //     <div >
          //     `;
          // if (curTabS.value === '进料量') {
          //   res += `
          //         <div class="flex align-start">
          //           <span class="mr-1">进料量</span>
          //           <span style="font-size: 12px;">${params[0].value}吨</span>
          //         </div>
          //       `;
          // }
          // if (curTabS.value === '运费') {
          //   res += `
          //         <div class="flex align-start">
          //           <span class="mr-1">运费</span>
          //           <span style="font-size: 12px;">${params[0].value}万元</span>
          //         </div>
          //       `;
          // }
          // res += '</div>';
          var res = "\n            <div >\n              <div class=\"flex align-start\">\n                <span class=\"mr-1\">\u8FDB\u6599\u91CF</span>\n                <span style=\"font-size: 12px;\">".concat(params[0].value, "\u5428</span>\n              </div>\n            </div>\n          ");
          return res;
        }
      };
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getFeedingTotalAsync();
            getFeedingRatioAsync();
            getFeedingTrendAsync();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return {
      summaryData: summaryData,
      tabs: tabs,
      curTab: curTab,
      tabClick: tabClick,
      // curTabS,
      // tabClickS,
      categoryFeedingCount: categoryFeedingCount,
      categoryPriceCount: categoryPriceCount,
      outweighOneDay: outweighOneDay
    };
  }
});